<div id="container">
	<h2>Made by Sumanyu Aggarwal</h2>
	<a href="https://github.com/SuPythony/Gamopedia" target="_blank">
		<i class="fab fa-github fa-lg" />
	</a>
</div>

<style lang="scss">
	#container {
		width: 100%;
		background-color: teal;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		bottom: 0px;
		left: 0px;
		font-size: 0.9em;
		h2 {
			margin: 0.7em;
		}
		a {
			color: white;
		}
	}
</style>
